(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.dshdReady) return;
      root.dataset.dshdReady = "true";
      var bar = root.querySelector("[data-dshd-bar]");
      var pauseBtn = root.querySelector("[data-dshd-pause]");
      var track = bar && bar.querySelector(".dshd-track");
      if (track) {
        var distance = track.scrollWidth / 2;
        if (distance > 0) track.style.animationDuration = Math.max(40, distance / 28) + "s";
      }
      if (bar && pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          var paused = bar.classList.toggle("is-paused");
          pauseBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
        });
      }
      var drawer = document.querySelector("[data-dshd-drawer]");
      function setDrawer(open) { if (drawer) drawer.hidden = !open; }
      var openBtn = root.querySelector("[data-dshd-open]");
      if (openBtn) openBtn.addEventListener("click", function () { setDrawer(true); });
      document.querySelectorAll("[data-dshd-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setDrawer(false); });
      });
      var search = document.querySelector("[data-dshd-search]");
      function setSearch(open) {
        if (!search) return;
        search.hidden = !open;
        if (open) {
          var input = search.querySelector("input");
          if (input) input.focus();
        }
      }
      var searchOpen = root.querySelector("[data-dshd-search-open]");
      if (searchOpen) searchOpen.addEventListener("click", function () { setSearch(true); });
      document.querySelectorAll("[data-dshd-search-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setSearch(false); });
      });
      var count = root.querySelector("[data-dshd-count]");
      var layer = document.querySelector("[data-dshd-cart]");
      var body = document.querySelector("[data-dshd-cartbody]");
      var foot = document.querySelector("[data-dshd-cartfoot]");
      var threshold = layer ? Math.round(parseFloat(layer.getAttribute("data-free-ship") || "0") * 100) : 0;
      var upsellHandles = layer ? (layer.getAttribute("data-upsells") || "").split(",").filter(Boolean) : [];
      var bundleHandle = layer ? (layer.getAttribute("data-bundle") || "") : "";
      var bundleCta = layer ? (layer.getAttribute("data-bundle-cta") || "Upgrade") : "Upgrade";
      var bundleNote = layer ? (layer.getAttribute("data-bundle-note") || "") : "";
      var upsellCache = {};

      function money(cents, currency) {
        return (cents / 100).toLocaleString("en-US", { style: "currency", currency: currency || "USD" });
      }
      function esc(value) {
        return String(value || "").replace(/[&<>"']/g, function (c) {
          if (c === "&") return "&" + "amp;";
          if (c === "<") return "&" + "lt;";
          if (c === ">") return "&" + "gt;";
          if (c === "\"") return "&" + "quot;";
          return "&" + "#39;";
        });
      }
      function looksLikeBundle(item) {
        var hay = ((item && (item.title || item.product_title) || "") + " " + ((item && item.handle) || "")).toLowerCase();
        return hay.indexOf("bundle") !== -1;
      }
      function isBundleItem(item) {
        if (!item) return false;
        if (bundleHandle && item.handle === bundleHandle) return true;
        return looksLikeBundle(item);
      }
      function cartHasBundle(cart) {
        return (cart.items || []).some(isBundleItem);
      }
      function firstAvailable(product) {
        var variant = null;
        (product.variants || []).forEach(function (v) { if (!variant && v.available) variant = v; });
        return variant || (product.variants || [])[0] || null;
      }
      function offerPrice(product, variant, currency) {
        var price = (variant && variant.price) || 0;
        var compare = (variant && variant.compare_at_price) || 0;
        if (product && isBundleItem(product)) compare = Math.max(compare, 10000);
        var struck = compare > price ? "<s>" + money(compare, currency) + "</s>" : "";
        return '<p class="dshd-upsell-price">' + money(price, currency) + struck + "</p>";
      }
      function setCount(n) {
        if (!count) return;
        count.textContent = n;
        count.hidden = n === 0;
      }
      function setCart(open) {
        if (!layer) return;
        if (open) {
          layer.hidden = false;
          layer.classList.remove("is-open");
          void layer.offsetWidth;
          layer.classList.add("is-open");
          return;
        }
        layer.classList.remove("is-open");
        setTimeout(function () {
          if (!layer.classList.contains("is-open")) layer.hidden = true;
        }, 520);
      }

      function comparesFor(cart) {
        var handles = [];
        (cart.items || []).forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });
        if (!handles.length) return Promise.resolve({});
        return Promise.all(handles.map(function (handle) {
          return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (products) {
          var map = {};
          products.forEach(function (product) {
            if (!product || !product.variants) return;
            product.variants.forEach(function (variant) {
              map[variant.id] = variant.compare_at_price || 0;
            });
          });
          return map;
        });
      }

      function render(cart, compares) {
        if (!body) return;
        compares = compares || {};
        setCount(cart.item_count || 0);
        var ship = document.querySelector("[data-dshd-ship]");
        var fill = document.querySelector("[data-dshd-shipfill]");
        var shipText = document.querySelector("[data-dshd-shiptext]");
        if (!cart.items || !cart.items.length) {
          if (ship) ship.hidden = true;
          var shopUrl = (layer && layer.getAttribute("data-shop-url")) || "/";
          var shopLabel = (layer && layer.getAttribute("data-shop-label")) || "Shop";
          body.innerHTML = '<p class="dshd-empty">Your bag is empty.</p><div class="dshd-upsell dshd-upsell--empty" data-dshd-upsell-empty></div><a class="dshd-shop" href="' + esc(shopUrl) + '">' + esc(shopLabel) + '</a>';
          if (foot) foot.hidden = true;
          return;
        }
        if (ship) {
          ship.hidden = false;
          if (fill) fill.style.width = "100%";
          if (shipText) shipText.textContent = "You've unlocked free shipping 🥳";
        }
        if (foot) foot.hidden = false;
        var before = 0;
        var lineOff = 0;
        body.innerHTML = cart.items.map(function (item) {
          var img = item.image ? (item.image + (item.image.indexOf("?") === -1 ? "?" : "&") + "width=300") : "";
          var option = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
          var bundle = isBundleItem(item);
          var compareLine = Number(compares[item.variant_id] || 0) * item.quantity;
          if (bundle) compareLine = Math.max(compareLine, 10000 * item.quantity);
          var reference = Math.max(compareLine, item.original_line_price || 0);
          before += reference;
          var struck = reference > item.final_line_price ? "<s>" + money(reference, cart.currency) + "</s>" : "";
          var deals = "";
          var allocations = item.line_level_discount_allocations || [];
          if (!allocations.length && item.discounts && item.discounts.length) {
            allocations = item.discounts.map(function (deal) {
              return { amount: deal.amount, discount_application: { title: deal.title } };
            });
          }
          allocations.forEach(function (deal) {
            var amount = deal.amount || 0;
            if (amount <= 0) return;
            lineOff += amount;
            var title = (deal.discount_application && deal.discount_application.title) || "Discount";
            deals += '<p class="dshd-deal">' + esc(title) + " – " + money(amount, cart.currency) + "</p>";
          });
          return '<article class="dshd-item">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div><p class="dshd-option">' + esc(option) + '</p>' +
            '<p class="dshd-itemname">' + esc(item.product_title) + '</p>' +
            '<p class="dshd-itemprice">' + money(item.final_line_price, cart.currency) + struck + '</p>' +
            deals +
            '<div class="dshd-itemtools"><div class="dshd-qty">' +
            '<button type="button" data-dshd-qty="-1" data-key="' + esc(item.key) + '">–</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-dshd-qty="1" data-key="' + esc(item.key) + '">+</button>' +
            '</div><button type="button" class="dshd-remove" data-dshd-remove data-key="' + esc(item.key) + '">Remove</button></div></div></article>';
        }).join("");
        var sub = document.querySelector("[data-dshd-subtotal]");
        var total = document.querySelector("[data-dshd-total]");
        var discount = document.querySelector("[data-dshd-discount]");
        var discountRow = document.querySelector("[data-dshd-discountrow]");
        var saved = before - (cart.total_price || 0) - lineOff;
        if (sub) sub.textContent = money(before, cart.currency);
        if (total) total.textContent = money(cart.total_price, cart.currency);
        if (discount && discountRow) {
          discountRow.hidden = saved <= 0;
          discount.textContent = saved > 0 ? "– " + money(saved, cart.currency) : "";
        }
      }

      function getProduct(handle) {
        if (!handle) return Promise.resolve(null);
        if (upsellCache[handle]) return Promise.resolve(upsellCache[handle]);
        return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) { if (product) upsellCache[handle] = product; return product; })
          .catch(function () { return null; });
      }

      function getUpsells() {
        if (!upsellHandles.length) return Promise.resolve([]);
        return Promise.all(upsellHandles.map(getProduct));
      }

      function suggestionCards(cart, products) {
        var html = "";
        products.forEach(function (product) {
          if (!product) return;
          if (isBundleItem(product)) return;
          var already = (cart.items || []).some(function (item) { return item.handle === product.handle; });
          if (already) return;
          var variant = firstAvailable(product);
          if (!variant) return;
          var img = product.featured_image || "";
          html += '<div class="dshd-upsell-card">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div><p class="dshd-upsell-name">' + esc(product.title) + '</p>' +
            offerPrice(product, variant, cart.currency) +
            '</div><button type="button" data-dshd-upsell-add data-id="' + variant.id + '">Add</button></div>';
        });
        return html;
      }

      function upgradeCard(cart, product) {
        if (!product) return "";
        var variant = firstAvailable(product);
        if (!variant) return "";
        var img = product.featured_image || "";
        var note = bundleNote ? '<p class="dshd-upsell-note">' + esc(bundleNote) + "</p>" : "";
        return '<div class="dshd-upsell-card dshd-upsell-card--upgrade">' +
          (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
          '<div>' +
          '<p class="dshd-upsell-name">' + esc(product.title) + "</p>" +
          offerPrice(product, variant, cart.currency) +
          note +
          '</div><button type="button" data-dshd-upsell-add data-id="' + variant.id + '">' + esc(bundleCta || "Upgrade") + "</button></div>";
      }

      function resolveBundleProduct(products) {
        if (bundleHandle) {
          var picked = products.filter(function (product) { return product && product.handle === bundleHandle; })[0];
          if (picked) return Promise.resolve(picked);
          return getProduct(bundleHandle);
        }
        var named = products.filter(function (product) { return product && looksLikeBundle(product); })[0];
        return Promise.resolve(named || null);
      }

      function paintUpgrade(cart, products) {
        var box = document.querySelector("[data-dshd-upgrade]");
        if (!box) return Promise.resolve();
        var hasItems = cart.items && cart.items.length;
        if (!hasItems || cartHasBundle(cart)) {
          box.hidden = true;
          box.innerHTML = "";
          return Promise.resolve();
        }
        return resolveBundleProduct(products || []).then(function (product) {
          var html = upgradeCard(cart, product);
          box.hidden = !html;
          box.innerHTML = html;
        });
      }

      function paintUpsell(cart) {
        var box = document.querySelector("[data-dshd-upsell]");
        var emptyBox = document.querySelector("[data-dshd-upsell-empty]");
        var left = threshold - (cart.total_price || 0);
        var hasItems = cart.items && cart.items.length;
        var unlocked = hasItems && left <= 0;
        return getUpsells().then(function (products) {
          return paintUpgrade(cart, products).then(function () {
            if (!upsellHandles.length || unlocked) {
              if (box) { box.hidden = true; box.innerHTML = ""; }
              if (emptyBox && unlocked) emptyBox.innerHTML = "";
              if (!upsellHandles.length && emptyBox) emptyBox.innerHTML = "";
              return;
            }
            var html = suggestionCards(cart, products);
            if (!hasItems) {
              if (box) { box.hidden = true; box.innerHTML = ""; }
              if (emptyBox) emptyBox.innerHTML = html;
              return;
            }
            if (!box) return;
            box.hidden = !html;
            box.innerHTML = html;
          });
        });
      }

      function paint(cart, open) {
        return comparesFor(cart).then(function (map) {
          render(cart, map);
          return paintUpsell(cart).then(function () {
            if (open) setCart(true);
            return cart;
          });
        });
      }

      function load(open) {
        return fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return paint(cart, open); })
          .catch(function () {});
      }

      function change(key, quantity) {
        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function (r) { return r.json(); }).then(function (cart) { return paint(cart, false); });
      }

      var cartOpen = root.querySelector("[data-dshd-cart-open]");
      if (cartOpen) cartOpen.addEventListener("click", function (event) {
        event.preventDefault();
        load(true);
      });
      document.querySelectorAll("[data-dshd-cart-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setCart(false); });
      });
      if (body) body.addEventListener("click", function (event) {
        var qty = event.target.closest("[data-dshd-qty]");
        var remove = event.target.closest("[data-dshd-remove]");
        var key = (qty || remove) && (qty || remove).getAttribute("data-key");
        if (!key) return;
        var current = qty ? Number(qty.parentNode.querySelector("span").textContent) : 0;
        var next = remove ? 0 : current + Number(qty.getAttribute("data-dshd-qty"));
        if (next < 0) next = 0;
        change(key, next);
      });
      if (layer) layer.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-dshd-upsell-add]");
        if (!btn) return;
        btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-id")), quantity: 1 }] })
        }).then(function () { return load(true); })
          .catch(function () { btn.disabled = false; });
      });
      document.addEventListener("cart:refresh", function () { load(true); });
      window.DsCartOpen = function () { load(true); };
      load(false);
      var spacer = document.querySelector("[data-dshd-spacer]");
      var lastY = window.pageYOffset || 0;
      var pending = false;
      var nextY = lastY;
      function headerHeight() {
        return root.offsetHeight || 104;
      }
      function syncSpacer() {
        if (spacer) spacer.style.height = headerHeight() + "px";
      }
      function readY(event) {
        var node = event && event.target;
        if (node && node !== document && node.nodeType === 1 && node.scrollTop > 0) return node.scrollTop;
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }
      function onScroll() {
        var cartOpen = document.querySelector("[data-dshd-cart].is-open");
        var menuOpen = document.querySelector("[data-dshd-drawer]:not([hidden])");
        var y = nextY;
        var dy = y - lastY;
        if (cartOpen || menuOpen || y <= 8) root.classList.remove("is-hidden");
        else if (dy > 2 && y > 40) root.classList.add("is-hidden");
        else if (dy < -2) root.classList.remove("is-hidden");
        lastY = y;
      }
      syncSpacer();
      window.addEventListener("resize", syncSpacer);
      document.addEventListener("scroll", function (event) {
        nextY = readY(event);
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          onScroll();
        });
      }, { passive: true, capture: true });
    }
    if (!window.DsCartBound) {
      window.DsCartBound = true;
      document.addEventListener("click", function (event) {
        var opener = event.target.closest("[data-dshd-cart-open], a[href$='/cart']");
        if (!opener || opener.closest("[data-dshd-cart]")) return;
        event.preventDefault();
        event.stopPropagation();
        var root = document.querySelector("[data-dshd]");
        if (root) init(root);
        if (window.DsCartOpen) window.DsCartOpen();
      }, true);
    }
    function boot(scope) { (scope || document).querySelectorAll("[data-dshd]").forEach(init); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
    else boot(document);
    document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.dshReady) return;
      root.dataset.dshReady = "true";
      const slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
      if (!slides.length) return;
      let index = 0;
      let timer = null;
      let paused = false;
      const autoplay = root.dataset.autoplay === "true" && slides.length > 1;
      const dots = Array.prototype.slice.call(root.querySelectorAll("[data-dot]"));
      const pauseBtn = root.querySelector("[data-pause]");
      const pauseIcon = root.querySelector("[data-pause-icon]");

      function videoFor(slide) {
        return slide ? slide.querySelector("video") : null;
      }
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          const on = i === index;
          slide.classList.toggle("is-on", on);
          const video = videoFor(slide);
          if (!video) return;
          if (on) {
            const play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle("is-on", i === index); });
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      function play() {
        stop();
        if (!autoplay || paused) return;
        timer = setInterval(function () { show(index + 1); }, 6500);
      }
      const prev = root.querySelector("[data-prev]");
      const next = root.querySelector("[data-next]");
      if (prev) prev.addEventListener("click", function () { show(index - 1); play(); });
      if (next) next.addEventListener("click", function () { show(index + 1); play(); });
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          show(Number(dot.getAttribute("data-dot")) || 0);
          play();
        });
      });
      if (pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          paused = !paused;
          if (pauseIcon) pauseIcon.textContent = paused ? "▶" : "❚❚";
          pauseBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
          if (paused) stop(); else play();
        });
      }
      show(0);
      play();
    }
    function boot(scope) { (scope || document).querySelectorAll("[data-dsh]").forEach(init); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
    else boot(document);
    document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
    if (!root || root.dataset.dsInitialized) return;
    root.dataset.dsInitialized = "true";

    function headerHeight() {
      const header = document.querySelector("#shopify-section-header sticky-header, #shopify-section-header .header-wrapper, #shopify-section-header header, sticky-header, header[role='banner']");
      if (!header) return 92;
      return Math.max(64, Math.round(header.getBoundingClientRect().height));
    }

    function offsetForHeader() {
      const height = headerHeight();
      root.style.setProperty("--ds-header-offset", height + "px");
      const headerSection = document.querySelector("#shopify-section-header");
      if (headerSection) {
        const hr = headerSection.getBoundingClientRect();
        if (hr.height > window.innerHeight * 0.45) {
          headerSection.style.pointerEvents = "none";
          const bar = headerSection.querySelector("header, .header, .header-wrapper");
          if (bar) bar.style.pointerEvents = "auto";
        }
      }
      document.querySelectorAll(".menu-drawer, .drawer-overlay, .cart-overlay, .background-overlay").forEach(function (node) {
        const open = node.closest("details[open], .active, .is-open");
        if (!open) node.style.pointerEvents = "none";
      });
      const probe = root.querySelector("[data-ds-atc], .ds-info");
      if (!probe) return;
      const box = probe.getBoundingClientRect();
      const x = Math.min(box.left + 24, box.right - 8);
      const y = Math.min(box.top + 16, box.bottom - 8);
      let topEl = document.elementFromPoint(x, y);
      let hops = 0;
      while (topEl && !root.contains(topEl) && hops < 6) {
        const blocker = topEl.closest("#shopify-section-header, sticky-header, .header-wrapper, .menu-drawer, .overlay, .drawer, .modal-overlay");
        if (!blocker) break;
        if (blocker.id === "shopify-section-header" || blocker.matches("sticky-header, .header-wrapper")) {
          const tall = blocker.getBoundingClientRect().height > 140;
          if (tall) blocker.style.pointerEvents = "none";
        } else {
          blocker.style.pointerEvents = "none";
        }
        topEl = document.elementFromPoint(x, y);
        hops += 1;
      }
    }

    offsetForHeader();
    window.addEventListener("resize", offsetForHeader);

    const state = {
      zoomOpen: false,
      zoomIndex: 0,
      zoomed: false,
      zoomX: 50,
      zoomY: 50
    };

    const el = {
      hero: root.querySelector("[data-ds-hero]"),
      heroVideo: root.querySelector("[data-ds-hero-video]"),
      thumbs: root.querySelector("[data-ds-thumbs]"),
      atc: root.querySelector("[data-ds-atc]"),
      atcLabel: root.querySelector("[data-ds-atc-label]"),
      atcSub: root.querySelector("[data-ds-atc-sub]"),
      form: root.querySelector("[data-ds-form]"),
      variantId: root.querySelector("[data-ds-variant-id]"),
      qtyHidden: root.querySelector("[data-ds-qty-input]"),
      zip: root.querySelector("[data-ds-zip]"),
      eta: root.querySelector("[data-ds-eta]"),
      zoom: root.querySelector("[data-ds-zoom]"),
      zoomCount: root.querySelector("[data-ds-zoom-count]"),
      zoomRail: root.querySelector("[data-ds-zoom-rail]"),
      zoomMain: root.querySelector("[data-ds-zoom-main]"),
      zoomFrame: root.querySelector("[data-ds-zoom-frame]"),
      zoomImg: root.querySelector("[data-ds-zoom-img]"),
      zoomVideo: root.querySelector("[data-ds-zoom-video]")
    };



    const picker = root.querySelector("[data-ds-picker]");
    const options = root.querySelector("[data-ds-options]");
    let activeProduct = null;
    let adding = false;
    function put(selector, text) {
      const node = root.querySelector(selector);
      if (node) node.textContent = text || "";
    }
    function optional(selector, text) {
      const node = root.querySelector(selector);
      if (node) { node.textContent = text || ""; node.hidden = !text; }
    }
    function dropCents(text) {
      return String(text || "").replace(/\.\d{2}\b/g, "");
    }
    function applyVariant() {
      const variant = options.selectedOptions[0];
      const available = !!variant && variant.dataset.available === "true";
      el.variantId.value = variant ? variant.value : "";
      el.atc.disabled = adding || !available;
      el.atc.dataset.soldout = String(!available);
      put("[data-ds-atc-label]", available ? "ADD TO CART" : (activeProduct ? "SOLD OUT" : "UNAVAILABLE"));
      put("[data-ds-atc-sub]", available ? "In-Stock: Ready to Ship" : "Currently unavailable");
      const price = dropCents(variant ? variant.dataset.price : "");
      const compare = dropCents(variant ? variant.dataset.compare : "");
      put("[data-ds-price]", price);
      optional("[data-ds-compare]", compare);
      optional("[data-ds-save]", dropCents(variant ? variant.dataset.save : ""));
      optional("[data-ds-atc-now]", available ? price : "");
      optional("[data-ds-atc-compare]", available ? compare : "");
      optional("[data-ds-atc-dash]", available ? "-" : "");
      put("[data-ds-cart-status]", "");
      paintAtcColor();
      paintSticky();
      paintAccordions();
    }
    function selectProduct(id, replaceGallery, variantId, matchingVariants) {
      const template = Array.from(root.querySelectorAll("template[data-ds-product]")).find(function (node) { return node.dataset.dsProduct === id; });
      if (!template) return;
      activeProduct = template;

      options.replaceChildren.apply(options, matchingVariants.map(function (choice) { return choice.option.cloneNode(true); }));
      options.value = variantId;
      root.querySelector("[data-ds-options-wrap]").hidden = options.options.length < 2;
      if (replaceGallery) {
        var incoming = template.content.querySelector("[data-pot-gallery]");
        var gallery = root.querySelector(".ds-gallery");
        if (incoming && gallery) gallery.innerHTML = incoming.innerHTML;
        el.hero = root.querySelector("[data-ds-hero]");
        el.heroVideo = root.querySelector("[data-ds-hero-video]");
        el.thumbs = root.querySelector("[data-ds-thumbs]");
        if (gallery) gallery.scrollLeft = 0;
        if (el.heroVideo && !el.heroVideo.hidden) {
          var play = el.heroVideo.play();
          if (play && play.catch) play.catch(function () {});
        }
        applySizeMedia();
      }
      const title = root.querySelector("[data-ds-title]");
      if (!title.dataset.customHeading) title.textContent = template.dataset.title;
      const blurb = root.querySelector("[data-ds-blurb]");
      const descriptionNode = template.content.querySelector("[data-pot-description]");
      const description = descriptionNode ? descriptionNode.innerHTML : "";
      if (blurb && !blurb.dataset.customBlurb && description) blurb.innerHTML = description;
      const details = root.querySelector("[data-ds-description]");
      if (details && !details.dataset.customDescription) details.innerHTML = (blurb && blurb.innerHTML) || description;
      applyVariant();
    }
    // Read existing Shopify options and IDs; never infer variants from product titles.
    const productChoices = [];
    root.querySelectorAll("template[data-ds-product]").forEach(function (template) {
      template.content.querySelectorAll("[data-pot-variants] option").forEach(function (option) {
        if (!option.dataset.size || !option.dataset.color) return;
        productChoices.push({template: template, option: option, size: option.dataset.size,
          color: option.dataset.color, key: JSON.stringify([template.dataset.dsProduct, option.dataset.size])});
      });
    });
    const sizeChoices = productChoices.filter(function (choice, index, all) {
      return all.findIndex(function (other) { return other.key === choice.key; }) === index;
    });
    let selectedSize = "";
    let selectedColor = "";
    function normalize(value) { return value.trim().toLowerCase(); }
    function swatchHex(name) {
      const n = normalize(name).replace(/colour/g, "color");
      const map = {
        white: "#f0f0f0", ivory: "#f0f0f0", cream: "#f0f0f0", bone: "#f0f0f0", beige: "#f0f0f0", offwhite: "#f0f0f0", "off white": "#f0f0f0",
        black: "#111111", charcoal: "#2a2a2a",
        red: "#c13b34", rust: "#9c4336", burgundy: "#7a2430",
        brown: "#6a3d2b", espresso: "#4b2c24", bark: "#6b4a3a", chocolate: "#4a2c22", tan: "#c4a574",
        grey: "#8a8a8a", gray: "#8a8a8a", "light grey": "#cfcfcf", "light gray": "#cfcfcf", silver: "#c0c0c0",
        blue: "#5d7fa6", navy: "#1c2e5a", sky: "#96a5b8",
        green: "#3d6b4f", pink: "#e2b8b8", yellow: "#e2c56b", orange: "#c46a2b", purple: "#6b4a7a",
        gold: "#c4a04a", terracotta: "#c46b4a"
      };
      if (map[n]) return map[n];
      const key = Object.keys(map).find(function (k) { return n.indexOf(k) > -1; });
      return key ? map[key] : "#c8bfb4";
    }
    function isLightHex(hex) {
      const h = hex.replace("#", "");
      if (h.length !== 6) return false;
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      return (r * 299 + g * 587 + b * 114) / 1000 > 170;
    }
    function paintAtcColor() {
      const name = selectedColor ? normalize(selectedColor) : "";
      const isWhite = !name || /white|ivory|cream|bone|beige/.test(name);
      const hex = isWhite ? "#f0f0f0" : (selectedColor ? swatchHex(selectedColor) : "#111111");
      const light = isLightHex(hex) || isWhite;
      const tone = light ? "light" : "dark";
      [el.atc, document.querySelector("[data-ds-sticky-atc]")].forEach(function (btn) {
        if (!btn) return;
        btn.style.backgroundColor = hex;
        btn.dataset.dsAtcTone = tone;
        btn.style.boxShadow = "none";
      });
    }
    function radioChoice(container, kind, value, labelText, checked, statusText, badge) {
      const label = document.createElement("label");
      label.className = "ds-choice" + (kind === "color" ? " ds-choice--color" : "");
      const input = document.createElement("input");
      input.type = "radio";
      input.name = "ds-" + kind + "-" + root.dataset.sectionId;
      input.value = value;
      input.setAttribute("data-ds-" + kind, "");
      input.checked = checked;
      input.setAttribute("aria-label", labelText + (statusText ? " (" + statusText + ")" : ""));
      const body = document.createElement("span");
      body.className = "ds-choice-body";
      if (kind === "color") {
        const hex = swatchHex(labelText);
        body.style.setProperty("--ds-swatch", hex);
        body.style.background = "transparent";
        const dot = document.createElement("span");
        dot.className = "ds-color-dot" + (statusText ? " is-soldout" : "") + (isLightHex(hex) ? " is-light" : "");
        dot.style.setProperty("--ds-swatch", hex);
        dot.style.backgroundColor = hex;
        dot.style.background = hex;
        dot.setAttribute("aria-hidden", "true");
        body.appendChild(dot);
        body.title = labelText;
      } else {
        body.appendChild(document.createTextNode(labelText));
        if (badge) {
          const tag = document.createElement("span");
          tag.className = "ds-new";
          tag.textContent = badge;
          body.appendChild(tag);
        }
      }
      label.appendChild(input);
      label.appendChild(body);
      container.appendChild(label);
    }
    function renderSizes() {
      const container = root.querySelector("[data-ds-sizes]");
      container.replaceChildren();
      sizeChoices.forEach(function (choice, index) {
        const duplicate = sizeChoices.some(function (other) { return other.key !== choice.key && normalize(other.size) === normalize(choice.size); });
        const isNew = index === 1 || /400\s*ml/i.test(String(choice.size || ""));
        radioChoice(container, "size", choice.key, choice.size + (duplicate ? " — " + choice.template.dataset.title : ""), choice.key === selectedSize, "", isNew ? "NEW" : "");
      });
    }
    function renderColors() {
      const choices = productChoices.filter(function (choice) { return choice.key === selectedSize; });
      const colors = choices.filter(function (choice, index, all) {
        return all.findIndex(function (other) { return normalize(other.color) === normalize(choice.color); }) === index;
      });
      if (!colors.some(function (choice) { return normalize(choice.color) === selectedColor; })) {
        const first = choices.find(function (choice) { return choice.option.dataset.available === "true"; }) || choices[0];
        selectedColor = first ? normalize(first.color) : "";
      }
      const colorLegend = root.querySelector("[data-ds-color-label]");
      if (colorLegend) colorLegend.textContent = "Choose Your Color";
      const container = root.querySelector("[data-ds-colors]");
      container.replaceChildren();
      colors.forEach(function (choice) {
        const available = choices.some(function (other) { return normalize(other.color) === normalize(choice.color) && other.option.dataset.available === "true"; });
        radioChoice(container, "color", normalize(choice.color), choice.color, normalize(choice.color) === selectedColor, available ? "" : "Sold out");
      });
    }
    function chooseCombination(preferredVariantId, replaceGallery) {
      const matches = productChoices.filter(function (choice) { return choice.key === selectedSize && normalize(choice.color) === selectedColor; });
      const choice = matches.find(function (item) { return item.option.value === preferredVariantId; }) ||
        matches.find(function (item) { return item.option.dataset.available === "true"; }) || matches[0];
      if (choice) {
        root.querySelector(".ds-gallery").hidden = false;
        selectProduct(choice.template.dataset.dsProduct, replaceGallery, choice.option.value, matches);
      } else {
        activeProduct = null;
        options.replaceChildren();
        root.querySelector("[data-ds-options-wrap]").hidden = true;
        applyVariant();
      }
    }
    function applySizeMedia() {
      var found = sizeChoices.find(function (choice) { return choice.key === selectedSize; });
      var label = found ? normalize(found.size) : "";
      var tiles = root.querySelectorAll(".ds-gallery [data-ds-thumb]");
      var tagged = false;
      tiles.forEach(function (tile) {
        if ((tile.getAttribute("data-sizes") || "").replace(/\|/g, "")) tagged = true;
      });
      if (!tagged) return;
      tiles.forEach(function (tile) {
        var raw = (tile.getAttribute("data-sizes") || "").toLowerCase();
        if (!raw.replace(/\|/g, "")) {
          tile.hidden = false;
          return;
        }
        tile.hidden = label ? raw.indexOf("|" + label + "|") === -1 : false;
      });
    }
    function paintAccordions() {
      var found = sizeChoices.find(function (choice) { return choice.key === selectedSize; });
      var label = found ? normalize(found.size) : "";
      root.querySelectorAll("[data-ds-acc-item]").forEach(function (item) {
        var rule = item.getAttribute("data-ds-acc-for") || "both";
        if (!rule || rule === "both" || !label) {
          item.hidden = false;
          return;
        }
        item.hidden = label.indexOf(rule) === -1;
      });
    }
    function selectSize(value) {
      selectedSize = value;
      renderSizes();
      renderColors();
      chooseCombination(null, true);
    }
    function selectColor(value) {
      selectedColor = value;
      renderColors();
      chooseCombination(null, false);
    }
    if (picker && options) {
      picker.hidden = false;
      picker.addEventListener("change", function (event) {
        if (event.target.matches("[data-ds-size]")) {
          selectSize(event.target.value);
        } else if (event.target.matches("[data-ds-color]")) {
          selectColor(event.target.value);
        } else if (event.target === options) applyVariant();
      });
      const initial = productChoices.find(function (choice) { return choice.template.dataset.dsProduct === picker.dataset.currentProduct && choice.option.value === choice.template.dataset.selectedVariant; }) || productChoices[0];
      if (initial) {
        selectedSize = initial.key;
        selectedColor = normalize(initial.color);
        renderSizes();
        renderColors();
        chooseCombination(initial.option.value, initial.template.dataset.dsProduct !== picker.dataset.currentProduct);
        applySizeMedia();
      } else {
        options.replaceChildren();
        applyVariant();
      }
    }

    function currentVariant() {
      return options && options.selectedOptions ? options.selectedOptions[0] : null;
    }
    function paintSticky() {
      const bar = document.querySelector("[data-ds-sticky]") || root.querySelector("[data-ds-sticky]");
      if (!bar) return;
      const variant = currentVariant();
      const title = bar.querySelector("[data-ds-sticky-title]");
      const sale = bar.querySelector("[data-ds-sticky-sale]");
      const comp = bar.querySelector("[data-ds-sticky-comp]");
      const btn = bar.querySelector("[data-ds-sticky-atc]");
      const atcLabel = bar.querySelector("[data-ds-sticky-atc-label]");
      const atcDash = bar.querySelector("[data-ds-sticky-atc-dash]");
      const atcCompare = bar.querySelector("[data-ds-sticky-atc-compare]");
      const atcNow = bar.querySelector("[data-ds-sticky-atc-now]");
      const available = !!(variant && variant.dataset.available === "true");
      const price = dropCents(variant ? (variant.dataset.price || "") : "");
      const compare = dropCents(variant && variant.dataset.compare ? variant.dataset.compare : "");
      if (title) title.textContent = "The Dessert Stove";
      if (sale) sale.textContent = price;
      if (comp) {
        comp.textContent = compare;
        comp.hidden = !compare;
      }
      if (atcLabel) atcLabel.textContent = available ? "ADD TO CART" : (variant ? "SOLD OUT" : "ADD TO CART");
      if (atcNow) atcNow.textContent = available ? price : "";
      if (atcCompare) {
        atcCompare.textContent = available ? compare : "";
        atcCompare.hidden = !(available && compare);
      }
      if (atcDash) {
        atcDash.textContent = available && price ? "-" : "";
        atcDash.hidden = !(available && price);
      }
      if (btn) btn.disabled = !available || adding;
      const sizeBox = bar.querySelector("[data-ds-sticky-sizes]");
      const colorBox = bar.querySelector("[data-ds-sticky-colors]");
      if (sizeBox) {
        sizeBox.innerHTML = "";
        sizeChoices.forEach(function (choice) {
          const btnSize = document.createElement("button");
          btnSize.type = "button";
          btnSize.className = "ds-sticky-size" + (choice.key === selectedSize ? " is-on" : "");
          btnSize.textContent = choice.size;
          btnSize.setAttribute("aria-label", "Size " + choice.size);
          btnSize.addEventListener("click", function () { selectSize(choice.key); });
          sizeBox.appendChild(btnSize);
        });
      }
      if (colorBox) {
        colorBox.innerHTML = "";
        const colorChoices = productChoices.filter(function (choice) { return choice.key === selectedSize; });
        const unique = colorChoices.filter(function (choice, index, all) {
          return all.findIndex(function (other) { return normalize(other.color) === normalize(choice.color); }) === index;
        });
        unique.forEach(function (choice) {
          const btnColor = document.createElement("button");
          btnColor.type = "button";
          btnColor.className = "ds-sticky-color" + (normalize(choice.color) === selectedColor ? " is-on" : "");
          btnColor.title = choice.color;
          btnColor.setAttribute("aria-label", "Color " + choice.color);
          btnColor.style.setProperty("--ds-swatch", swatchHex(choice.color));
          btnColor.style.background = swatchHex(choice.color);
          btnColor.addEventListener("click", function () { selectColor(normalize(choice.color)); });
          colorBox.appendChild(btnColor);
        });
      }
      paintAtcColor();
    }

    const sticky = root.querySelector("[data-ds-sticky]");
    if (sticky && sticky.parentElement !== document.body) document.body.appendChild(sticky);

    function showSticky(show) {
      if (!sticky) return;
      sticky.hidden = !show;
      sticky.style.display = show ? "block" : "none";
    }

    // Show the sticky bar only once the main Add to Cart button has scrolled
    // out of view (above the viewport), on both desktop and mobile. Uses an
    // IntersectionObserver instead of a scroll handler so it stays accurate
    // even as the header height or page layout changes.
    function watchAtc() {
      const atc = root.querySelector("[data-ds-form] [data-ds-atc]") || el.atc;
      if (!atc || !sticky) return;
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(function (entries) {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          if (entry.isIntersecting) {
            showSticky(false);
          } else {
            // Only reveal once the button has passed above the viewport;
            // stay hidden if it simply hasn't been scrolled to yet.
            showSticky(entry.boundingClientRect.top < 0);
          }
        }, { threshold: 0 });
        observer.observe(atc);
      } else {
        function fallback() { showSticky(atc.getBoundingClientRect().bottom <= 0); }
        window.addEventListener("scroll", fallback, { passive: true });
        window.addEventListener("resize", fallback);
        fallback();
      }
    }
    watchAtc();
    showSticky(false);
    paintSticky();
    if (sticky) {
      const stickyBtn = sticky.querySelector("[data-ds-sticky-atc]");
      if (stickyBtn && el.form) stickyBtn.addEventListener("click", function () { el.form.requestSubmit(); });
    }

    function cdnWidth(url, width) {
      if (!url) return "";
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, "$1" + width);
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
    }

    function sameFile(a, b) {
      if (!a || !b) return false;
      const left = String(a).split("?")[0];
      const right = String(b).split("?")[0];
      return left === right || left.indexOf(right) > -1 || right.indexOf(left) > -1;
    }

    function collectMedia() {
      const media = [];
      const seen = {};
      function push(item) {
        if (!item || !(item.src || item.preview)) return;
        const key = String(item.src || item.preview).split("?")[0];
        if (!key || seen[key]) return;
        seen[key] = true;
        media.push(item);
      }
      if (el.heroVideo) {
        const source = el.heroVideo.querySelector("source");
        const src = (source && (source.getAttribute("src") || source.src)) || el.heroVideo.getAttribute("src") || el.heroVideo.currentSrc || "";
        if (src) {
          push({
            type: "video",
            src: src,
            preview: el.heroVideo.getAttribute("poster") || "",
            alt: ""
          });
        }
      }
      if (el.thumbs) {
        el.thumbs.querySelectorAll("[data-ds-thumb]").forEach(function (thumb) {
          push({
            type: thumb.getAttribute("data-type") || "image",
            src: thumb.getAttribute("data-src") || "",
            preview: thumb.getAttribute("data-preview") || thumb.getAttribute("data-src") || "",
            alt: (thumb.querySelector("img") && thumb.querySelector("img").alt) || ""
          });
        });
      }
      return media;
    }

    function showStage(item) {
      if (!item) return;
      const empty = root.querySelector("[data-ds-hero-empty]");
      if (empty) empty.hidden = true;
      const isVideo = item.type === "video" && item.src;
      if (el.hero) {
        el.hero.hidden = !!isVideo;
        if (isVideo) {
          el.hero.removeAttribute("src");
          el.hero.removeAttribute("srcset");
        } else if (item.src) {
          el.hero.hidden = false;
          const next = cdnWidth(item.src, 1000);
          if (el.hero.getAttribute("src") !== next) {
            el.hero.src = next;
            el.hero.srcset = "";
          }
          el.hero.alt = item.alt || "";
        }
      }
      if (!el.heroVideo) return;
      if (isVideo) {
        el.heroVideo.hidden = false;
        el.heroVideo.controls = false;
        el.heroVideo.muted = true;
        el.heroVideo.loop = true;
        el.heroVideo.playsInline = true;
        el.heroVideo.setAttribute("playsinline", "");
        el.heroVideo.setAttribute("webkit-playsinline", "");
        el.heroVideo.poster = item.preview || "";
        while (el.heroVideo.firstChild) el.heroVideo.removeChild(el.heroVideo.firstChild);
        const source = document.createElement("source");
        source.src = item.src;
        source.type = "video/mp4";
        el.heroVideo.appendChild(source);
        el.heroVideo.src = item.src;
        el.heroVideo.load();
        const play = el.heroVideo.play();
        if (play && play.catch) play.catch(function () {});
      } else {
        el.heroVideo.pause();
        el.heroVideo.removeAttribute("src");
        while (el.heroVideo.firstChild) el.heroVideo.removeChild(el.heroVideo.firstChild);
        el.heroVideo.hidden = true;
        el.heroVideo.load();
      }
    }

    function currentShowingSrc() {
      if (el.heroVideo && !el.heroVideo.hidden && (el.heroVideo.currentSrc || el.heroVideo.getAttribute("src"))) {
        return el.heroVideo.currentSrc || el.heroVideo.getAttribute("src");
      }
      if (el.hero && !el.hero.hidden && el.hero.src) return el.hero.src;
      return "";
    }

    function indexFromSrc(src) {
      const media = collectMedia();
      const found = media.findIndex(function (m) {
        return sameFile(m.src, src) || sameFile(m.preview, src);
      });
      return found > -1 ? found : 0;
    }

    function applyZoomTransform() {
      if (!el.zoomFrame) return;
      if (!state.zoomed) {
        el.zoomFrame.style.transform = "scale(1) translate(0,0)";
        el.zoomFrame.style.transformOrigin = "center center";
        if (el.zoom) el.zoom.classList.remove("is-zoomed");
        return;
      }
      el.zoomFrame.style.transformOrigin = state.zoomX + "% " + state.zoomY + "%";
      el.zoomFrame.style.transform = "scale(2.35)";
      if (el.zoom) el.zoom.classList.add("is-zoomed");
    }

    function paintZoom() {
      if (!el.zoom) return;
      const media = collectMedia();
      if (!media.length) return;
      if (state.zoomIndex < 0) state.zoomIndex = media.length - 1;
      if (state.zoomIndex >= media.length) state.zoomIndex = 0;
      const item = media[state.zoomIndex];
      const isVideo = item.type === "video" && item.src;
      if (el.zoomCount) el.zoomCount.textContent = (state.zoomIndex + 1) + " / " + media.length;
      if (el.zoomImg) {
        el.zoomImg.hidden = !!isVideo;
        if (!isVideo) {
          const hi = cdnWidth(item.src || item.preview, 2000);
          if (el.zoomImg.getAttribute("src") !== hi) el.zoomImg.src = hi;
          el.zoomImg.alt = item.alt || "";
        }
      }
      if (el.zoomVideo) {
        if (isVideo) {
          el.zoomVideo.hidden = false;
          if (el.zoomVideo.getAttribute("src") !== item.src) {
            el.zoomVideo.src = item.src;
            el.zoomVideo.poster = item.preview || "";
            el.zoomVideo.load();
          }
          const play = el.zoomVideo.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          el.zoomVideo.pause();
          el.zoomVideo.removeAttribute("src");
          el.zoomVideo.hidden = true;
        }
      }
      if (el.zoomRail) {
        el.zoomRail.innerHTML = media.map(function (m, i) {
          const preview = m.preview || m.src;
          return (
            '<button type="button" class="ds-zoom-rail-item' + (i === state.zoomIndex ? " is-active" : "") + '" data-ds-zoom-item="' + i + '" aria-label="Image ' + (i + 1) + '">' +
              '<img src="' + cdnWidth(preview, 280) + '" alt="">' +
            "</button>"
          );
        }).join("");
      }
      applyZoomTransform();
    }

    function openZoom(index) {
      const media = collectMedia();
      if (!media.length || !el.zoom) return;
      state.zoomIndex = typeof index === "number" ? index : 0;
      state.zoomOpen = true;
      state.zoomed = false;
      if (el.zoom.parentElement !== document.body) document.body.appendChild(el.zoom);
      el.zoom.hidden = false;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      paintZoom();
    }

    function closeZoom() {
      state.zoomOpen = false;
      state.zoomed = false;
      if (el.zoom) el.zoom.hidden = true;
      if (el.zoomVideo) el.zoomVideo.pause();
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      applyZoomTransform();
    }

    function toggleZoomAt(event) {
      if (!state.zoomOpen) return;
      const media = collectMedia()[state.zoomIndex];
      if (media && media.type === "video") return;
      const pic = el.zoomImg && !el.zoomImg.hidden ? el.zoomImg : null;
      if (!state.zoomed && event && pic) {
        const box = pic.getBoundingClientRect();
        if (box.width && box.height) {
          state.zoomX = ((event.clientX - box.left) / box.width) * 100;
          state.zoomY = ((event.clientY - box.top) / box.height) * 100;
        }
      }
      state.zoomed = !state.zoomed;
      applyZoomTransform();
    }

    function stepZoom(dir) {
      state.zoomed = false;
      state.zoomIndex += dir;
      paintZoom();
    }

    root.addEventListener("click", function (event) {
      const thumb = event.target.closest("[data-ds-thumb]");
      if (thumb) {
        const item = {
          type: thumb.getAttribute("data-type") || "image",
          src: thumb.getAttribute("data-src"),
          preview: thumb.getAttribute("data-preview")
        };
        if (item.type === "image") openZoom(indexFromSrc(item.src || item.preview));
        return;
      }
      const openZoomBtn = event.target.closest("[data-ds-open-zoom]");
      if (openZoomBtn) {
        openZoom(indexFromSrc(currentShowingSrc()));
        return;
      }
      const zoomClose = event.target.closest("[data-ds-zoom-close]");
      if (zoomClose) {
        closeZoom();
        return;
      }
      const zoomPrev = event.target.closest("[data-ds-zoom-prev]");
      if (zoomPrev) {
        stepZoom(-1);
        return;
      }
      const zoomNext = event.target.closest("[data-ds-zoom-next]");
      if (zoomNext) {
        stepZoom(1);
        return;
      }
      const zoomToggle = event.target.closest("[data-ds-zoom-toggle]");
      if (zoomToggle) {
        toggleZoomAt();
        return;
      }
      const zoomItem = event.target.closest("[data-ds-zoom-item]");
      if (zoomItem) {
        state.zoomed = false;
        state.zoomIndex = Number(zoomItem.getAttribute("data-ds-zoom-item")) || 0;
        paintZoom();
        return;
      }
      if (event.target.closest("[data-ds-zoom-img], [data-ds-zoom-video]")) {
        toggleZoomAt(event);
        return;
      }
      if (event.target.closest("[data-ds-zoom-main], [data-ds-zoom-bg], [data-ds-zoom]")) {
        closeZoom();
      }
    });

    function arrivalWindow() {
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + 5);
      end.setDate(end.getDate() + 11);
      const opts = { month: "short", day: "numeric" };
      return start.toLocaleDateString("en-US", opts) + "–" + end.toLocaleDateString("en-US", opts);
    }

    function renderEta() {
      if (!el.eta) return;
      const raw = el.zip ? el.zip.value.replace(/\D/g, "") : "";
      if (raw.length >= 5) {
        el.eta.textContent = "Arrives " + arrivalWindow() + " to " + raw.slice(0, 5);
        return;
      }
      if (raw.length > 0) {
        el.eta.textContent = "Enter a 5-digit ZIP";
        return;
      }
      el.eta.textContent = "Arrives in 5–11 days.";
    }

    if (el.zip && el.eta) {
      el.zip.addEventListener("input", function () {
        const zip = el.zip.value.replace(/\D/g, "").slice(0, 5);
        if (el.zip.value !== zip) el.zip.value = zip;
        renderEta();
      });
      renderEta();
    }

    if (el.form) {
      el.form.addEventListener("submit", async function (event) {
        event.preventDefault();
        const id = el.variantId && el.variantId.value;
        if (!id || adding || el.atc.dataset.soldout === "true") return;
        adding = true;
        picker.disabled = true;
        el.atc.disabled = true;
        put("[data-ds-atc-label]", "ADDING…");
        const stickyLabel = document.querySelector("[data-ds-sticky-atc-label]");
        const stickyBtn = document.querySelector("[data-ds-sticky-atc]");
        if (stickyLabel) stickyLabel.textContent = "ADDING…";
        if (stickyBtn) stickyBtn.disabled = true;
        put("[data-ds-cart-status]", "");
        try {
          const res = await fetch(el.form.action.replace(/\/$/, "") + ".js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          });
          const result = await res.json();
          if (!res.ok) throw new Error(typeof result.description === "string" ? result.description : "Could not add to cart. Please try again.");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } catch (error) {
          put("[data-ds-cart-status]", error.message || "Could not add to cart. Please try again.");
        } finally {
          adding = false;
          picker.disabled = false;
          el.atc.disabled = el.atc.dataset.soldout === "true";
          put("[data-ds-atc-label]", el.atc.disabled ? "SOLD OUT" : "ADD TO CART");
          paintSticky();
        }
      });
    }

    if (el.zoom) {
      el.zoom.addEventListener("click", function (event) {
        if (event.target.closest("[data-ds-zoom-close]")) {
          closeZoom();
          return;
        }
        if (event.target.closest("[data-ds-zoom-prev]")) {
          stepZoom(-1);
          return;
        }
        if (event.target.closest("[data-ds-zoom-next]")) {
          stepZoom(1);
          return;
        }
        if (event.target.closest("[data-ds-zoom-toggle]")) {
          toggleZoomAt();
          return;
        }
        const zoomItem = event.target.closest("[data-ds-zoom-item]");
        if (zoomItem) {
          state.zoomed = false;
          state.zoomIndex = Number(zoomItem.getAttribute("data-ds-zoom-item")) || 0;
          paintZoom();
          return;
        }
        if (event.target.closest("[data-ds-zoom-img], [data-ds-zoom-video]")) {
          toggleZoomAt(event);
          return;
        }
        if (event.target.closest("[data-ds-zoom-main], [data-ds-zoom-bg], [data-ds-zoom-frame]")) {
          closeZoom();
        }
      });
    }

    document.addEventListener("keydown", function (event) {
      if (!state.zoomOpen) return;
      if (event.key === "Escape") closeZoom();
      if (event.key === "ArrowLeft") stepZoom(-1);
      if (event.key === "ArrowRight") stepZoom(1);
    });

    if (el.zoomMain) {
      el.zoomMain.addEventListener("mousemove", function (event) {
        if (!state.zoomOpen || !state.zoomed) return;
        const box = el.zoomMain.getBoundingClientRect();
        state.zoomX = ((event.clientX - box.left) / box.width) * 100;
        state.zoomY = ((event.clientY - box.top) / box.height) * 100;
        applyZoomTransform();
      });
      let touchX = 0;
      el.zoomMain.addEventListener("touchstart", function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        touchX = event.changedTouches[0].clientX;
      }, { passive: true });
      el.zoomMain.addEventListener("touchend", function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        const dx = event.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 50) stepZoom(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    }
    function boot(scope) { scope.querySelectorAll("[data-ds-section]").forEach(init); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); }, { once: true });
    else boot(document);
    document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
